// @flow
import * as React from 'react';
import ProductGroupCardContainer from 'app/common/react/components/profile/ProductGroupCard/ProductGroupCardContainer';
import ProfileBoardCardWrapper from 'app/common/react/components/profile/ProfileBoards/ProfileBoardCardWrapper';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import { Box } from 'gestalt';

type Props = {|
  isOwnProfile: boolean,
  productGroups: Array<Object>,
  user: ProfileUser,
|};

const CONTAINER_WIDTH = 260;
const LAYOUT_TYPE = 'square';

export default function ProductGroupsCarousel({ isOwnProfile, productGroups, user }: Props) {
  return (
    <Box display="flex">
      {productGroups.map((productGroup: Object, index: number) => (
        <Box key={index}>
          <Box justifyContent="center" display="flex" width="100%">
            <Box maxWidth={780} width="100%">
              <ProfileBoardCardWrapper
                key={productGroup.id}
                containerWidth={CONTAINER_WIDTH}
                inListView={false}
              >
                <ProductGroupCardContainer
                  productGroup={productGroup}
                  isOwnProfile={isOwnProfile}
                  username={user.username}
                  layout={LAYOUT_TYPE}
                />
              </ProfileBoardCardWrapper>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
